module.exports = __webpack_public_path__ + "img/2.9e071719.png";